"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_e__sim__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "6e3f9b7e-1bfe-4f21-8ba2-26d37fb16a77",
    "data-name": "93d1184e-e332-4212-af37-c79b6eb932f7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "9427f1f9-2000-400d-84b9-a155a7d8b8e9",
    x1: 124.55,
    y1: -13804.37,
    x2: 139.45,
    y2: -13789.45,
    gradientTransform: "translate(0 13959.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bfcdf063-f3a5-4ff5-ace0-444949dc0d02",
    x1: 100.55,
    y1: -13804.37,
    x2: 115.45,
    y2: -13789.45,
    xlinkHref: "#9427f1f9-2000-400d-84b9-a155a7d8b8e9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3f91f529-11da-41ee-a80d-474630bdb20d",
    x1: 76.55,
    y1: -13804.37,
    x2: 91.45,
    y2: -13789.45,
    xlinkHref: "#9427f1f9-2000-400d-84b9-a155a7d8b8e9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "350c8fba-76f6-404f-8b6b-33d7b6e3b18d",
    x1: 52.55,
    y1: -13804.37,
    x2: 67.45,
    y2: -13789.45,
    xlinkHref: "#9427f1f9-2000-400d-84b9-a155a7d8b8e9"
  })), /*#__PURE__*/React.createElement("title", null, "e-sim-hi-dark"), /*#__PURE__*/React.createElement("path", {
    d: "M108,48.33a4,4,0,0,1-4-4v-24a4,4,0,1,1,8,0v24A4,4,0,0,1,108,48.33Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,48.33a4,4,0,0,1-4-4v-24a4,4,0,1,1,8,0v24A4,4,0,0,1,132,48.33Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,48.33a4,4,0,0,1-4-4v-24a4,4,0,0,1,8,0v24A4,4,0,0,1,84,48.33Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,48.33a4,4,0,0,1-4-4v-24a4,4,0,0,1,8,0v24A4,4,0,0,1,60,48.33Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,176a4,4,0,0,1-4-4V148a4,4,0,0,1,8-.16v24a4,4,0,0,1-3.84,4.16Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132,174a4,4,0,0,1-4-4v2a4,4,0,0,0,8,0v-2A4,4,0,0,1,132,174Z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128,151.83V172a4,4,0,0,0,8,0V151.83Z",
    opacity: 0.2,
    fill: "url(#9427f1f9-2000-400d-84b9-a155a7d8b8e9)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,176a4,4,0,0,1-4-4V148a4,4,0,0,1,8-.16v24a4,4,0,0,1-3.84,4.16Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108,174a4,4,0,0,1-4-4v2a4,4,0,0,0,8,0v-2A4,4,0,0,1,108,174Z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104,151.83V172a4,4,0,0,0,8,0V151.83Z",
    opacity: 0.2,
    fill: "url(#bfcdf063-f3a5-4ff5-ace0-444949dc0d02)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,176a4,4,0,0,1-4-4V148a4,4,0,1,1,8-.16v24A4,4,0,0,1,84.16,176Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84,174a4,4,0,0,1-4-4v2a4,4,0,0,0,8,0v-2A4,4,0,0,1,84,174Z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80,151.83V172a4,4,0,0,0,8,0V151.83Z",
    opacity: 0.2,
    fill: "url(#3f91f529-11da-41ee-a80d-474630bdb20d)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,176a4,4,0,0,1-4-4V148a4,4,0,1,1,8-.16v24A4,4,0,0,1,60.16,176Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,174a4,4,0,0,1-4-4v2a4,4,0,0,0,8,0v-2A4,4,0,0,1,60,174Z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56,151.83V172a4,4,0,0,0,8,0V151.83Z",
    opacity: 0.2,
    fill: "url(#350c8fba-76f6-404f-8b6b-33d7b6e3b18d)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "72970005-36df-47ab-8ce9-3cb0496d7760",
    "data-name": "3f838525-44cf-41fa-bb64-c07df06bc731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "259e3125-5ef1-4241-ab46-3bd4cd30659a",
    "data-name": "1d394fae-1cb9-46c3-b4a2-d4d877dff599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13fb192e-fb47-4ea9-9528-3b8b5ebd8ea1",
    "data-name": "b37ae195-b5e5-4253-8ecf-526a89327406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "659ff2ef-c33a-42e9-add3-da1d34b5b3cb",
    "data-name": "f1b46269-5f25-4e20-a1f0-c2c9ca850a05"
  }, /*#__PURE__*/React.createElement("g", {
    id: "158e4a44-cb42-4d3d-976f-6e3d6e25fe66",
    "data-name": "bbfab9c7-1e4f-4cc9-8659-3ef94a427969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d6904931-8736-41c2-88fe-7d6c9084164d",
    "data-name": "105c86e3-9e47-4640-b0cd-a8644f5486d7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "661fca94-7b94-4949-9183-75305adcea95",
    "data-name": "c447bf98-a8f9-4603-b40e-a7852e97f4d5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c547078f-0777-44df-ae34-d7ee4eaf8289",
    "data-name": "ebf4e99a-61ce-4092-a285-819ccba8765f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7854d89f-978b-4e39-9fac-547170b31b6a",
    "data-name": "1d783251-7c85-43ef-b907-52a267b5abb7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,121.56V144a16,16,0,0,0,16,16h96a16,16,0,0,0,16-16V133.17l-.06-.06V48a16,16,0,0,0-16-16H48A16,16,0,0,0,32,48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,158H48a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h96a16,16,0,0,0,16-16v-2A16,16,0,0,1,144,158Z",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  })))))))))), /*#__PURE__*/React.createElement("path", {
    d: "M91,56h38.11A6.88,6.88,0,0,1,136,62.86v66.26a6.88,6.88,0,0,1-6.88,6.88H62.88A6.88,6.88,0,0,1,56,129.12h0V90.86A6.84,6.84,0,0,1,58,86L86.15,58A6.88,6.88,0,0,1,91,56Z",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.11,56H91a6.91,6.91,0,0,0-4.86,2L58,86a6.91,6.91,0,0,0-2,4.88v2A7,7,0,0,1,58,88L86.12,60A6.87,6.87,0,0,1,91,58h38.11A6.88,6.88,0,0,1,136,64.88v-2A6.88,6.88,0,0,0,129.15,56Z",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,80a16,16,0,1,0,16,16A16,16,0,0,0,96,80Zm7.83,20.3a8.55,8.55,0,0,1-10,4.28,9.08,9.08,0,0,1-5.11-3.82,9.21,9.21,0,0,1-1.16-2.58L87.49,98a9.54,9.54,0,0,1-.29-1.58,9.09,9.09,0,0,1,0-1.65v-.17a11.84,11.84,0,0,1,.35-2.3,13.84,13.84,0,0,1,4.5-7.2,14.85,14.85,0,0,1,4.38-2.57c.44-.17.88-.32,1.31-.45l.82-.22a17.11,17.11,0,0,1,2-.36,8.36,8.36,0,0,1,2,0l.32.08A6.59,6.59,0,0,0,97.66,88v.21A10.87,10.87,0,0,1,101,89.5a8,8,0,0,1,2.22,2l.13.19a8,8,0,0,1,1,2,9.6,9.6,0,0,1,.37,2.32v.31a8.61,8.61,0,0,1-.94,3.92Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }));
}

var _default = ic_e__sim__dark;
exports.default = _default;